export default __webpack_public_path__ + "static/media/first-watch-me.f1eda70b.mp3";